import Alert from '@customink/pigment-react/lib/components/Alert';

export default function UnavailableSizes({}) {
  return (
    <Alert severity="error">
      You have sizes in your design that are not currently available for this
      product
    </Alert>
  );
}
